import { render } from "./SpacesSuggestions.vue?vue&type=template&id=77f9aa97&scoped=true&ts=true"
import script from "./SpacesSuggestions.vue?vue&type=script&lang=ts"
export * from "./SpacesSuggestions.vue?vue&type=script&lang=ts"

import "./SpacesSuggestions.vue?vue&type=style&index=0&id=77f9aa97&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f9aa97"]])

export default __exports__